import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"320px","width":"450px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "title mc",
  style: {}
}
const _hoisted_6 = {
  class: "fw600 fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = ["src", "height", "width"]
const _hoisted_9 = {
  style: {"line-height":"16px","height":"50px","padding":"0 10px","width":"calc(100% - 80px)"},
  class: "fl text-left"
}
const _hoisted_10 = { class: "fs14 fw600 mt10" }
const _hoisted_11 = {
  key: 0,
  class: "fs12 lgrey"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 1,
  class: "fs10 lgrey"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  class: "",
  style: {}
}
const _hoisted_17 = { class: "fs16 fw600 mt20" }
const _hoisted_18 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_21 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}
const _hoisted_22 = {
  key: 1,
  class: "with_white_bg dgrey fs16 pointer centered w100 lgreyBg disabled radb10",
  style: {"line-height":"50px","height":"50px"}
}
const _hoisted_23 = {
  key: 0,
  class: "fs14 fw400"
}
const _hoisted_24 = {
  key: 1,
  class: "fs14 fw400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ChangeLocationModal",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll ChangeLocationModal",
    onBeforeClose: _ctx.fadeOutModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        (_ctx.willSelectLoctag)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ofs centered",
              style: _normalizeStyle({
                    height: `${_ctx.contentHeight}px`,
                    overscrollBehavior: 'contain',
                })
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`title.change_location`)), 1)
              ]),
              _hoisted_7,
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`${_ctx.willSelectLoctag.keyword}`, `${_ctx.width}x${_ctx.width}`, true)),
                height: _ctx.width,
                width: _ctx.width,
                class: "fl"
              }, null, 8, _hoisted_8),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.willSelectLoctag.keyword), 1),
                (_ctx.willSelectLoctag.address)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.willSelectLoctag.address) + " ", 1),
                      _hoisted_12,
                      _createElementVNode("a", {
                        href: _ctx.locationHref(),
                        target: "_blank",
                        class: "pointer"
                      }, _toDisplayString(_ctx.$t(`location.confirm_google_map`)), 9, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true),
                ([`online`, `online_oauth`].includes(_ctx.willSelectLoctag.location_type))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t(`location.online`)), 1))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t(`text.want_change_location`)), 1)
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          (true && !_ctx.isPreview)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                id: "roomCloseButton",
                class: "w100 skyblueBg fs16 pointer centered radb10",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fixLocation && _ctx.fixLocation(...args)))
              }, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t(`title.change_location`)), 1)
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_22, [
                (_ctx.isPreview)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, "プレビューのため確定できません"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_24, "未入力です"))
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeClose"]))
}